import React from 'react';
import KenGrid from '../../../../global_components/KenGrid';
import KenLoader from '../../../../Components/KenLoader/index';

import { Grid } from '@material-ui/core';

const FacultyFeedbackHistory = ({ feedbackHistoryData }) => {
  const masterHead = [
    {
      Header: '',
      accessor: 'cursor',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject Code',
      accessor: 'code',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject Name',
      accessor: 'name',
      disableGlobalFilter: false,
    },
    {
      Header: 'Average Feedback',
      accessor: 'singleaverage',
      disableGlobalFilter: false,
    },
  ];
  const feedbackData =
    feedbackHistoryData?.courseList?.length > 0 &&
    feedbackHistoryData.courseList.map((historyData) => {
      const name = historyData?.courseName != null ? historyData?.courseName.split('-') : ['',''];
      return {
        code: name[0],
        name: name[1],
        singleaverage: historyData.singleSubjectAverage,
        allPametersAverageinSingleSubject:
          historyData.allPametersAverageinSingleSubject,
      };
    });

  return (
    <Grid container>
      <Grid className="allsubjectAvgGrid">
        <b>Overall average feedback: </b>
        {parseFloat(feedbackHistoryData.AllSubjectsAverage).toFixed(2)}
      </Grid>
      <Grid item xs={12}>
        <KenGrid
          columns={masterHead}
          data={feedbackData.length > 0 ? feedbackData : []}
          pagination={{ disabled: true }}
          toolbarDisabled={true}
          isCollasable={true}
          component={CollapseData}
        />
      </Grid>
    </Grid>
  );
};
const CollapseData = (props) => {
  const [loader, setLoader] = React.useState(false);
  const header = [
    {
      Header: 'Parameter Name',
      accessor: 'Parameter Name',
      disableGlobalFilter: false,
    },
    {
      Header: 'Rating',
      accessor: 'Rating',
      disableGlobalFilter: false,
    },
  ];
  const data = Object.entries(
    props?.original.allPametersAverageinSingleSubject
  ).map(([key, value]) => {
    return {
      'Parameter Name': key,
      Rating: value,
    };
  });

  return (
    <div className="facultyfeedback">
      {loader ? <KenLoader /> : null}
      <Grid item xs={12} className="nestedFeedbackHistory">
        <KenGrid
          columns={header}
          data={data}
          pagination={{ disabled: true }}
          toolbarDisabled={true}
        />
      </Grid>
    </div>
  );
};
export default FacultyFeedbackHistory;
